import {} from "../mod/index.js";
import { nodeKeyWithoutId } from "../node/index.js";
export function importNodeRules(mod, targetMod, node) {
    const nodeKey = nodeKeyWithoutId(node);
    for (const [key, ruleEntry] of targetMod.ruleEntries) {
        const [firstKey, secondKey] = key.split(" ");
        if (firstKey === nodeKey || secondKey === nodeKey) {
            mod.ruleEntries.set(key, ruleEntry);
        }
    }
}
//# sourceMappingURL=importNodeRules.js.map